<ng-container thr-parent-form>
    <div class="row">
        <div class="col-12 mb-3 mb-sm-4">
            <h3 class="mat-subheading-1 text-blue font-weight-bold">
                <span *ngIf="!isLegalPerson">{{ 'full-data.us-person-for-tax'|translate }}</span>
                <span *ngIf="isLegalPerson">{{ 'full-data.american-entity'|translate }}</span>
            </h3>
            <mat-radio-group [name]="prefix + 'YesNoUS'" [(ngModel)]="tax.isUSPersonFiscal" (ngModelChange)="onFiscalCountryChange()" [required]="true" [disabled]="isDisabled">
                <div class="row">
                    <div class="col-6 col-sm-3">
                        <mat-radio-button [name]="prefix + 'NoUS'" color="blue-gray" [value]="false">
                            {{ 'general.no'|translate }}
                        </mat-radio-button>
                    </div>
                    <div class="col-6 col-sm-3">
                        <mat-radio-button [name]="prefix + 'YesUS'" color="blue-gray" [value]="true">
                            {{ 'general.yes'|translate }}
                        </mat-radio-button>
                    </div>
                </div>
            </mat-radio-group>
            <div class="row justify-content-end" *ngIf="tax.isUSPersonFiscal">
                <div class="col-12 col-sm-9">
                    <mat-form-field class="full-width">
                        <input [name]="prefix + 'TINUS'" matInput [placeholder]="'form.tin-us'|translate" required [disabled]="isDisabled" [(ngModel)]="tax.TINNumber" #tinUSCtrl="ngModel">
                        <mat-error *ngIf="tinUSCtrl.hasError('required')">
                            {{ 'form.validation.required'|translate }}
                        </mat-error>
                        <mat-hint class="font-italic">
                            {{ 'full-data.tin-us-help'|translate }}
                        </mat-hint>
                    </mat-form-field>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-12 mb-3 mb-sm-4">
            <h3 class="mat-subheading-1 text-blue font-weight-bold">
                <span *ngIf="!isLegalPerson">{{ 'full-data.resident-country-other-us'|translate }}</span>
                <span *ngIf="isLegalPerson">{{ 'full-data.non-american-entity'|translate }}</span>
            </h3>
            <mat-radio-group [name]="prefix + 'YesNo'" [(ngModel)]="tax.isOtherCountryPersonFiscal" (ngModelChange)="onFiscalCountryChange()" [required]="true" [disabled]="isDisabled">
                <div class="row">
                    <div class="col-6 col-sm-3">
                        <mat-radio-button [name]="prefix + 'No'" color="blue-gray" [value]="false">
                            {{ 'general.no'|translate }}
                        </mat-radio-button>
                    </div>
                    <div class="col-6 col-sm-3">
                        <mat-radio-button [name]="prefix + 'Yes'" color="blue-gray" [value]="true">
                            {{ 'general.yes'|translate }}
                        </mat-radio-button>
                    </div>
                </div>
            </mat-radio-group>
            <ng-container *ngIf="tax.isOtherCountryPersonFiscal">
                <input type="checkbox" class="d-none" [name]="prefix + 'OneFiscalCountry'" [ngModel]="fiscalCountriesComplete" required />

                <table class="table participants mb-4" *ngIf="tax.fiscalCountries.length > 0">
                    <thead>
                        <tr>
                            <th>{{ 'form.country'|translate }}</th>
                            <th>{{ 'form.tin'|translate }}</th>
                            <th class="d-none d-md-table-cell">{{ 'form.reason'|translate }}</th>
                            <th width="90px"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-template ngFor let-fiscalCountry [ngForOf]="tax.fiscalCountries">
                            <tr>
                                <td>
                                    <ng-template ngFor let-country [ngForOf]="countries">
                                        <strong *ngIf="fiscalCountry.name === country.id.value">{{ country.name }}</strong>
                                    </ng-template>
                                </td>
                                <td>
                                    <strong *ngIf="!fiscalCountry.isTINNotAvailable">{{ fiscalCountry.TINNumber }}</strong>
                                    <strong *ngIf="fiscalCountry.isTINNotAvailable">-</strong>
                                </td>
                                <td class="d-none d-md-table-cell" [ngSwitch]="fiscalCountry.TINNotAvailableReason">
                                    <strong *ngSwitchCase="TINNotAvailableReason.NOT_EMIT_TIN">{{ 'form.tin-not-available-reason.RA'|translate }}</strong>
                                    <strong *ngSwitchCase="TINNotAvailableReason.CANNOT_BE_REVEALED">{{ 'form.tin-not-available-reason.RC'|translate }}</strong>
                                    <strong *ngSwitchCase="TINNotAvailableReason.OTHER_REASON">{{ 'form.tin-not-available-reason.RB'|translate }}</strong>
                                    <strong *ngSwitchDefault>-</strong>
                                </td>
                                <td class="text-right">
                                    <button type="button" class="mat-elevation-z0" mat-icon-button (click)="onEdit(fiscalCountry)" *ngIf="!isDisabled">
                                        <i class="icon-edit"></i>
                                    </button>
                                    <button type="button" class="mat-elevation-z0" mat-icon-button (click)="onRemove(fiscalCountry)" *ngIf="!isDisabled">
                                        <i class="icon-delete"></i>
                                    </button>
                                </td>
                            </tr>
                        </ng-template>
                    </tbody>
                </table>

                <ng-container *ngIf="!adding && !editing">
                    <div class="row justify-content-between mb-4" *ngIf="!isDisabled">
                        <div class="col-12 col-sm-6 col-md-4">
                            <button type="button" class="full-width mat-elevation-z0" mat-raised-button color="gray" (click)="onAdd()">
                                {{ 'general.add-other'|translate }}
                            </button>
                        </div>
                    </div>
                </ng-container>

                <ng-container *ngIf="adding || editing">
                    <div class="row justify-content-end mb-4">
                        <div class="col-12 col-sm-9">
                            <div class="row">
                                <div class="col-12 col-lg-5">
                                    <mat-form-field class="full-width mb-3 mb-sm-4 mb-lg-0">
                                        <mat-select [name]="prefix + 'Country'" [placeholder]="'form.country'|translate" required [disabled]="isDisabled" [(ngModel)]="currentFiscalCountry.name" #countryCtrl="ngModel">
                                            <ng-template ngFor let-country [ngForOf]="countries">
                                                <mat-option [value]="country.id.value" *ngIf="country.id.value !== 'US'">
                                                    {{ country.name }}
                                                </mat-option>
                                            </ng-template>
                                        </mat-select>
                                        <mat-error *ngIf="countryCtrl.hasError('required')">
                                            {{ 'form.validation.required'|translate }}
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="col-12 col-sm-8 col-lg-4">
                                    <mat-form-field class="full-width mb-3 mb-sm-0">
                                        <input [name]="prefix + 'TIN'" matInput [placeholder]="'form.tin'|translate" required [disabled]="currentFiscalCountry.isTINNotAvailable || isDisabled" [(ngModel)]="currentFiscalCountry.TINNumber" #tinCtrl="ngModel">
                                        <mat-error *ngIf="tinCtrl.hasError('required')">
                                            {{ 'form.validation.required'|translate }}
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="col-12 col-sm-4 col-lg-3 mb-3 mb-sm-0 mt-sm-2 mt-md-3">
                                    <mat-checkbox [name]="prefix + 'TINNotAvailable'" [disabled]="isDisabled" [(ngModel)]="currentFiscalCountry.isTINNotAvailable" (ngModelChange)="onResize()">
                                        {{ 'form.tin-not-available'|translate }}
                                    </mat-checkbox>
                                </div>
                            </div>
                            <div class="row justify-content-end" *ngIf="currentFiscalCountry.isTINNotAvailable">
                                <div class="col-12 col-lg-7">
                                    <label class="d-block">{{ 'full-data.indicates-reason'|translate }}</label>
                                    <mat-radio-group [name]="prefix + 'NotTINReason'" [(ngModel)]="currentFiscalCountry.TINNotAvailableReason" [required]="true" [disabled]="isDisabled">
                                        <div class="mb-3">
                                            <mat-radio-button [name]="prefix + 'RA'" color="blue-gray" [value]="TINNotAvailableReason.NOT_EMIT_TIN">
                                                {{ 'form.tin-not-available-reason.RA'|translate }}
                                            </mat-radio-button>
                                        </div>
                                        <div class="mb-3">
                                            <mat-radio-button [name]="prefix + 'RC'" color="blue-gray" [value]="TINNotAvailableReason.CANNOT_BE_REVEALED">
                                                {{ 'form.tin-not-available-reason.RC'|translate }}
                                            </mat-radio-button>
                                        </div>
                                        <div>
                                            <mat-radio-button [name]="prefix + 'RB'" color="blue-gray" [value]="TINNotAvailableReason.OTHER_REASON">
                                                {{ 'form.tin-not-available-reason.RB'|translate }}
                                            </mat-radio-button>
                                        </div>
                                    </mat-radio-group>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row justify-content-between mb-3 mb-sm-4" *ngIf="!isDisabled">
                        <div class="col-12 col-sm-6 col-md-4">
                            <button type="button" class="full-width mat-elevation-z0" mat-raised-button color="gray" (click)="onCancel()" *ngIf="tax.fiscalCountries.length > 0">
                                {{ 'general.cancel'|translate }}
                            </button>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4 mt-3 mt-sm-0">
                            <button type="button" class="full-width mat-elevation-z0" mat-raised-button color="blue" [disabled]="!currentFiscalCountry.isComplete()" (click)="onSave()">
                                {{ 'general.add'|translate }}
                            </button>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
        </div>
    </div>
</ng-container>